import React from 'react';
import { CurrentWinnersContainer, TopWinnersContainer } from '@pascal/pascal-core';
import { CurrentAndTopWinnersItem } from '../currentAndTopWinners';

export const TopAndCurrentWinnersWrapper = ({ isTopWinners }) => {
  return isTopWinners ? (
    <TopWinnersContainer
      renderCurrentOrTopWinnerItem={(betData) => (
        <CurrentAndTopWinnersItem betData={betData} key={betData.id} />
      )}
    />
  ) : (
    <CurrentWinnersContainer
      renderCurrentOrTopWinnerItem={(betData) => (
        <CurrentAndTopWinnersItem betData={betData} key={betData.id} />
      )}
    />
  );
};
